module.exports = __webpack_public_path__ + "static/media/elaborated-white.050f8f37.svg";